import React from 'react';
import { connect } from 'react-redux';
import { preguntas } from '../properties'

const mapState = (state) => {
    return {
        nombre: state.global.nombre,
        usuario: state.miPerfil.usuario
    };
}

const mapDispatch = (dispatch) => {
    return {
        pasoSiguiente: () => {
            dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_ELIMINAR"});
        },
        setP1: (obj) => {
            dispatch({ "type": "MI_PERFIL_SET_P1", "p": obj.p, "id": obj.id });
        },
        setP2: (obj) => {
            dispatch({ "type": "MI_PERFIL_SET_P2", "p": obj.p, "id": obj.id });
        },
        reset: () => {
            dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_ELIMINAR" });
        },
        addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
    }
}

class PasoUnoEliminarCuenta extends React.Component {
    state = {}
    siguiente = () => {
        /*let p1 = 4;
        let p2 = 6;
        this.props.setP1({id: p1, p: preguntas[p1 - 1].p});
        this.props.setP2({id: p2, p: preguntas[p2 - 1].p});*/
        this.props.pasoSiguiente();
    }
    cancelar = () => {
        this.props.reset();
        $("#modal-eliminar-cuenta").modal("toggle");
        this.props.addEvento("Cancelar-EliminarCuenta");
    }

	render() {
		return <div className="peticion-eliminar">
            <div>
              <img className="icono-eliminar" src={ require("../img/trash.png") } />
              <h5 className="blue-text">
                Petición para eliminar cuenta
              </h5>
            </div>
            <hr className="mt-34" />
            <div className="texto-17">
                <p className="center-text-mobile">{this.props.nombre}, lamentamos que te vayas. Vas a eliminar tu cuenta permanentemente. No podrás ingresar a la aplicación Soy Cliente GNP, ni a los servicios de Call Center. ¿Estás seguro que deseas continuar?</p>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <div className="text-center aceptar-cancelar-btn mt-50">
                        <a onClick={this.cancelar}>Cancelar</a>
                        <a onClick={this.siguiente} className="orange-btn">Aceptar</a>
                    </div>
                </div>
            </div>
        </div>
	}
}

export default connect(mapState, mapDispatch)(PasoUnoEliminarCuenta);



// WEBPACK FOOTER //
// ./src/miPerfil/pasoUnoEliminarCuenta.cmpt.js